export const LANGUAGE = {
    EN: "en-gb",
    DE: "de-de",
    DE_AT: "de-at",
    DE_CH: "de-ch",
    FR: "fr-fr",
    IT: "it-it",
    NL: "nl-nl",
};

// This object should contain all languages that useCompanyDetails.languageSelectionCollection collection has.
export const SUPPORTED_LANGUAGE = {
    en_GB: LANGUAGE.EN,
    de_DE: LANGUAGE.DE,
    ch_DE: LANGUAGE.DE_CH,
    at_DE: LANGUAGE.DE_AT,
    it_IT: LANGUAGE.IT,
    fr_FR: LANGUAGE.FR,
    nl_NL: LANGUAGE.NL,
};

export const loadMessagesJson = (lang) => {
    return new Promise((res) => {
        switch (lang) {
            case "de-de":
                import("../messages_de_DE.json").then((data) => {
                    res(data?.default);
                });
                break;
            case "de-ch":
                import("../messages_de_CH.json").then((data) => {
                    res(data?.default);
                });
                break;
            case "de-at":
                import("../messages_de_AT.json").then((data) => {
                    res(data?.default);
                });
                break;
            case "en-gb":
                import("../messages_GB.json").then((data) => {
                    res(data?.default);
                });
                break;
            case "fr-fr":
                import("../messages_fr_FR.json").then((data) => {
                    res(data?.default);
                });
                break;
            case "it-it":
                import("../messages_it_IT.json").then((data) => {
                    res(data?.default);
                });
                break;
            case "nl-nl":
                import("../messages_nl_NL.json").then((data) => {
                    res(data?.default);
                });
                break;
            default:
        }
    });
};
